import axios from 'axios';
import { useEffect } from 'react'
import { BASE_URL } from '../constants';

export function DocumentTitle(title) {
    useEffect(() => {
        document.title = title;
    }, [title]);
}

export function paramsToObject(entries) {
    const result = {}
    for (const [key, value] of entries) { // each 'entry' is a [key, value] tupple
        result[key] = value;
    }
    return result;
}

export async function checkLogin() {
    try {
        const res = await axios.get(`${BASE_URL}/auth/login.php`);
        const data = await res.data;

        return data.status == 'success';
    } catch (error) {
        console.log(error);
    }
}

export async function getGrades() {
    try {
        const res = await axios.get(`${BASE_URL}/constants/grades.php`);
        const data = await res.data.data;
        
        return data;
    } catch (error) {
        console.log(error);
        
    }
}

export async function getSubjects() {
    try {
        const res = await axios.get(`${BASE_URL}/constants/subjects.php`);
        const data = await res.data.data;
        
        return data;
    } catch (error) {
        console.log(error);
        
    }
}

export async function encryptHref(plaintext) {
    // axios.get(`${BASE_URL}/encrypt.php?text=${plaintext}`).then(res => {
    //     return res.data
    // }).catch(error => {
    //     console.log(error);
    // })

    try {
        const res = await axios.get(`${BASE_URL}/encrypt.php?text=${plaintext}`);
        const data = await res.data;
        
        return data;
    } catch (error) {
        console.log(error);
    }
}